import { render } from "./CaracProdutoRepeticao.vue?vue&type=template&id=36549f74&scoped=true"
import script from "./CaracProdutoRepeticao.vue?vue&type=script&lang=js"
export * from "./CaracProdutoRepeticao.vue?vue&type=script&lang=js"

import "./CaracProdutoRepeticao.vue?vue&type=style&index=0&id=36549f74&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36549f74"]])

export default __exports__